<template>
  <div class="product-cnt">
    <div class="ty-banner-1">
      <img
        alt="河南万杰智能科技股份"
        src="@img/subpage-banner.jpg"
        title="河南万杰智能科技股份"
      />
    </div>
    <search-bar></search-bar>
    <div class="blk-main content clearafter">
      <div class="blk plc">
        <div class="p12-curmbs-1" navcrumbs="">
          <b>您的位置:</b>
          <router-link to="/">主页</router-link>
          &gt;
          <router-link to="/products/all">产品展示</router-link>
          &gt;
          <router-link v-if="curType" :to="curType">{{
            curTypeName
          }}</router-link>
          &gt; {{ detailContent.product_name }}
        </div>
      </div>
      <div class="clear"></div>
      <div class="blk-xs fl">
        <div class="fdh-01 blk">
          <div class="fdh-01-tit"><h3>产品展示</h3></div>
          <div class="fdh-01-nav">
            <div
              class="fdh-01-nav-one"
              v-for="(product, index) in productTypes"
              :key="index"
            >
              <h3 :class="product.name | toPy | compare(curType, product.id)">
                <router-link :to="product.name | toPy('/products/')">{{
                  product.name
                }}</router-link>
              </h3>
            </div>
          </div>
          <div class="clear"></div>
        </div>
      </div>
      <div class="blk-sm fr">
        <div class="p15-showcase blk">
          <!-- <div class="p15-showcase-left"> -->
          <swiper
            class="p15-showcase-left"
            :options="swiperOption"
            ref="swiperOption"
            v-if="detailContent.product_img_pc"
          >
            <swiper-slide
              class="banner-slide"
              v-for="(item, index) in detailContent.product_img_pc"
              :key="index"
            >
              <img :src="item" :alt="detailContent.product_name" />
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
            <div
              class="swiper-button-prev swiper-button-white"
              slot="button-prev"
            ></div>
            <div
              class="swiper-button-next swiper-button-white"
              slot="button-next"
            ></div>
          </swiper>
          <!-- </div> -->
          <div class="p15-showcase-right">
            <div class="p15-showcase-right-tit">
              <span>{{ detailContent.product_name }}</span>
            </div>
            <div class="p15-showcase-right-con">
              <p v-for="(item, index) in product_attr" :key="index">
                {{ item }}
              </p>
            </div>
            <div class="clear"></div>
            <div class="pc-cx-tel-1">
              <div class="pc-cx-tel-1-t1">
                <a href="" target="_blank">在线咨询</a>
              </div>
              <div class="pc-cx-tel-1-t2">订购热线 400-677-1996</div>
            </div>
          </div>
          <div class="clear"></div>
        </div>
        <div class="p14-prodcontent-1 blk">
          <div
            class="p14-prodcontent-1-desc  endit-content"
            v-html="detailContent.product_detail"
          ></div>
          <div class="clear"></div>
        </div>
        <div class="p14-product-2 blk">
          <div class="p14-product-2-tit">
            <b>热品推荐</b>
            <span>/ Hot product</span>
          </div>
          <div class="p14-product-2-list">
            <dl v-for="(item, index) in products" :key="index">
              <dt>
                <router-link
                  target="_blank"
                  :to="item.product_class_id | findpy(productTypes, item.id)"
                >
                  <img
                    :alt="'<b>' + item.product_name + '</b>'"
                    :src="item.product_img_pc[0]"
                    :title="'<b>' + item.product_name + '</b>'"
                  />
                </router-link>
              </dt>
              <dd>
                <h3>
                  <router-link
                    target="_blank"
                    :to="item.product_class_id | findpy(productTypes, item.id)"
                    >{{ item.product_name }}</router-link
                  >
                </h3>
              </dd>
            </dl>
          </div>
          <div class="clear"></div>
        </div>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
import searchBar from "../common/searchBar.vue";
import utils from "@/api/to_py.js";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
var that;
export default {
  data() {
    return {
      productTypes: [],
      curType: null,
      curTypeId: null,
      curTypeName: null,
      detailContent: {},
      swiperOption: {
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        pagination: {
          el: ".swiper-pagination",
          type: "fraction"
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        observeParents: true,
        observer: true
      },
      product_attr: [],
      products: []
    };
  },
  metaInfo() {
    return {
      title: this.detailContent.seo_title || this.detailContent.product_name,
      meta: [
        {
          name: "keywords",
          content:
            this.detailContent.seo_keyword || this.detailContent.product_name
        },
        {
          name: "description",
          content:
            this.detailContent.seo_info || this.detailContent.product_name
        }
      ]
    };
  },
  components: {
    searchBar,
    swiper,
    swiperSlide
  },
  beforeCreate() {
    that = this;
  },
  mounted() {
    this.getRroductType();
    this.curType = this.$route.params.type;
    this.getHotPro();
  },
  watch: {
    $route(to, from) {
      this.urlFindId();
    }
  },
  methods: {
    getHotPro() {
      this.$post("/Product/product_info_list", {
        is_recommend: 1,
        limit: 4
      }).then(response => {
        this.products = response.data || [];
      });
    },
    urlFindId() {
      // console.log(this.$route);
      this.curType = this.$route.params.type;
      if (this.curType != "all") {
        this.productTypes.forEach(element => {
          if (this.curType == utils.ConvertPinyin(element.name)) {
            // console.log(element.id, element.name);
            this.curTypeId = element.id;
            this.curTypeName = element.name;
          }
        });
      } else {
        this.curTypeId = null;
        this.curTypeName = null;
      }
      this.product_info_detail();
    },
    product_info_detail: function() {
      this.$post("/Product/product_info_detail", {
        id: this.$route.params.id
      }).then(response => {
        this.detailContent = response.data || {};
        this.product_attr = response.data.product_attr.split(";") || [];
      });
    },
    getRroductType: function() {
      this.$post("/Product/product_class_list", {}).then(response => {
        this.productTypes = response.data || [];
        this.urlFindId();
      });
    }
  },
  filters: {
    findpy(id, arrs, idd) {
      var baseurl = "/product/";
      arrs.forEach(element => {
        if (element.id == id) {
          baseurl += utils.ConvertPinyin(element.name) + "/" + idd + ".html";
          return;
        }
      });
      return baseurl;
    },
    toPy(parm, url) {
      var str = utils.ConvertPinyin(parm);
      if (url) str = url + str;
      return str;
    },
    compare(parm, type, id) {
      return parm == type ? "nav-active" : "";
    },
    toArray(str, parm) {
      return str.split(parm);
    }
  }
};
</script>
<style lang="less">
.endit-content {
  img {
    display: inline-block;
  }
  video {
    width: 60%;
    margin: 0 auto 15px;
  }
  * {
    max-width: 100% !important;
  }
}
</style>
<style lang="less" scoped>
@import "~@css/warp.less";
.product-cnt {
  background: rgba(247, 247, 247, 1);
  padding-bottom: 200px;

  .p15-showcase {
    position: relative;
    padding: 20px 36px 20px 20px;
    margin-bottom: 15px;
    background: #fff;
    border: 1px solid #eee;

    .p15-showcase-left {
      position: relative;
      width: 44.7%;
      height: 390px;
      float: left;
      line-height: 0;
      overflow: hidden;
      border: 1px solid #e7e7e7;
      margin-right: 3.3%;
      img {
        max-width: 100%;
      }
    }
    .p15-showcase-right {
      width: 51.6%;
      float: left;
      .p15-showcase-right-con {
        line-height: 24px;
        font-size: 14px;
        max-height: 168px;
        margin-bottom: 86px;
        overflow: hidden;
      }
      .p15-showcase-right-tit {
        height: 40px;
        font-size: 24px;
        line-height: 40px;
        color: rgba(69, 69, 69, 1);
        margin-bottom: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .pc-cx-tel-1 {
        width: 48.5%;
        height: 56px;
        border-top: 2px solid #e6e6e6;
        padding-top: 15px;
        position: absolute;
        bottom: 16px;
        right: 4%;
        .pc-cx-tel-1-t1 {
          width: 114px;
          height: 44px;
          background: rgba(19, 181, 179, 1);
          font-size: 18px;
          line-height: 44px;
          text-align: center;
          float: right;
          a {
            display: block;
            color: #fff;
          }
        }
        .pc-cx-tel-1-t2 {
          height: 56px;
          padding-left: 70px;
          background: url(~@img/pc-xc-icon2.png) no-repeat 10px top;
          font-size: 19px;
          line-height: 46px;
          color: rgba(69, 69, 69, 1);
          p {
            line-height: 24px;
          }
        }
      }
    }
  }

  .p14-prodcontent-1 {
    background: #fff;
    padding: 32px 0 42px;
    margin-bottom: 22px;

    .p14-prodcontent-1-desc {
      padding-left: 15px;
      padding-right: 15px;
    }
  }
  .p14-product-2 {
    .p14-product-2-tit {
      height: 46px;
      line-height: 46px;
      border-bottom: 2px solid rgba(236, 236, 236, 1);
      margin-bottom: 30px;
      padding-top: 26px;
      b {
        display: inline-block;
        font-size: 24px;
        font-weight: normal;
        color: rgba(102, 102, 102, 1);
        border-bottom: 2px solid rgba(249, 131, 83, 1);
      }
      span {
        font-size: 17px;
        color: rgba(153, 153, 153, 1);
        text-transform: uppercase;
      }
    }
    .p14-product-2-list {
      dl {
        float: left;
        width: 23.8%;
        border: 1px solid #dfdfdf;
        margin-right: 1.5%;
        box-sizing: border-box;
        &:last-child {
          margin-right: 0;
        }
        &:hover {
          border-color: #13b5b3;
          h3 a {
            color: #13b5b3;
          }
        }
        dt {
          width: 100%;
          height: 219px;
          overflow: hidden;
          background: #ffffff;
        }
        img {
          margin: 0 auto;
          display: block;
          max-width: 100%;
          max-height: 100%;
        }
        dd {
          padding: 10px 28px 10px 10px;
          position: relative;
          background: #ffffff;
        }
        h3 {
          height: 30px;
          font-size: 16px;
          font-weight: normal;
          line-height: 30px;
          text-align: center;
          color: rgba(51, 51, 51, 1);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          a {
            color: rgba(51, 51, 51, 1);
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/products/detail.vue